import $ from "../../libs/jquery-3.3.1.min.js";
import {Draggable, InertiaPlugin, gsap} from "../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import * as Impetus from "../../libs/impetus-pixijs.js";
import 'pixi.js/math-extras';
import {BaseMiniGame} from "../minigames/BaseMiniGame";
import {BaseGameMyst} from "../base/BaseGameMyst";

export class Map extends BaseMiniGame {

  // Constructor
  constructor(data, game) {
    super(data);

    this.game = game;
    this.$mapEl = $("#map");

    // Can the map be shown?
    this.disabled = true;
    // Is the map currently shown?
    this.mapShown = false;

    // Reward impetus array
    this.impetus = [];
    this.rewardLastDraggedEl = null;
    this.rewardzIndexTimeout = false;
    this.rewardzIndexCounter = 0;
    // When more reward are added, smaller they become
    // Reduce rewards width by this percentage
    this.rewardWidthMulti = 0.065;
    // Limit how small reward can become
    // Only allow downsizing up to 47.5% of themselves
    this.rewardMinWidthPerc = 0.475;

    // First time user open the map
    this.firstVisit = true;
    // Is the tutorial completed?
    // Tutorial shown when first time opening map
    this.tutorialCompleted = false;
    // Current tutorial popup index
    this.mapTutorialStep = 0;
    // Number of reward for current visitor
    this.completedCount = 0;

    // Animation timeline
    this.currentTimeline = null;
    this.popupTimeline = null;

    // Register GSAP plugins
    gsap.registerPlugin(Draggable, InertiaPlugin);

    // Init rewards
    this.initRewards();
  }

  enableDebug() {
    // Open map without tutorial
    // Used for quick debugging
    this.tutorialCompleted = true;
    this.firstVisit = false;
    this.showMap();
  }

  /**
   * Init rewards in map, allow user to drag rewards
   */
  initRewards() {
    $("#map .map-reward").each((i, el) => {
      const $el = $(el);

      // Init impetus
      this.impetus.push(
        new Impetus({
          source: el,
          bounce: true,
          multiplier: 0.75,
          friction: 0.875,
          update: (x, y) => {
            // Increase z-index counter
            if (this.rewardLastDraggedEl !== el) {
              this.rewardzIndexCounter++;
            }
            this.rewardLastDraggedEl = el;

            // Update position and z-indexes
            $el.css({
              "left": x,
              "top": y,
              "right": "unset",
              "bottom": "unset",
              "z-index": this.rewardzIndexCounter
            });
          }
        })
      );
    });
  }

  /**
   * Enable rewards for the current user
   * @param scanData
   * @param additionalRFIDs
   */
  updateRewardsAndTutorial(scanData, additionalRFIDs = []) {
    // Set map pins as completed
    $("#map .pin").each((i, el) => {
      const pinQuestId = $(el).data("quete-id");
      const rfid = BaseGameMyst.getStationRFID(pinQuestId);
      const isCompleted = ["completed"].includes(BaseGameMyst.findStationScanData(rfid, scanData)) || (additionalRFIDs.includes(rfid));
      $(el).toggleClass("completed", isCompleted);
      $(el).toggleClass("current", this.game.currentQuestID && this.game.currentQuestID == pinQuestId);
    });

    // Set map rewards as completed
    this.completedCount = 0;
    let groupCompletedCount = {"1": 0, "2": 0, "3": 0, "4": 0};
    $("#map .map-reward").each((i, el) => {
      const $el = $(el);
      const rewardRfid = BaseGameMyst.getStationRFID($el.data("quete-id"));
      const rewardQueteCompleted = ["completed"].includes(BaseGameMyst.findStationScanData(rewardRfid, scanData)) || (additionalRFIDs.includes(rewardRfid));
      const rewardGroupId = $el.data("group-id")
      $el.toggleClass("completed", rewardQueteCompleted)

      if (rewardQueteCompleted) {
        $el.attr("data-item-index", this.completedCount);

        // Increase global completed count
        this.completedCount++;

        // Increase group completed count
        if (Number.isInteger(groupCompletedCount[rewardGroupId])) groupCompletedCount[rewardGroupId]++;
      }
    });

    // Update reward width, when more reward are added, smaller they become
    // Update reward impetus position
    $("#map .map-reward").each((i, el) => {
      const $el = $(el);
      const rewardRfid = BaseGameMyst.getStationRFID($el.data("quete-id"));
      const rewardQueteCompleted = ["completed"].includes(BaseGameMyst.findStationScanData(rewardRfid, scanData)) || (additionalRFIDs.includes(rewardRfid));

      if (rewardQueteCompleted) {
        // Update reward width, when more reward are added, smaller they become
        const originalWidth = parseFloat($el.attr("data-original-width"));
        const reduction = originalWidth * (this.completedCount * this.rewardWidthMulti);

        // Calculate minWidth as a percentage of originalWidth
        const minWidth = originalWidth * this.rewardMinWidthPerc;
        // Ensure newWidth doesn't go below the calculated minWidth
        const newWidth = Math.max(originalWidth - reduction, minWidth);
        $el.width(newWidth);

        // Update reward impetus position
        this.impetus[i].setBoundX([5, $("#map-rewards-area").outerWidth() - $el.outerWidth() - 5]);
        this.impetus[i].setBoundY([5, $("#map-rewards-area").outerHeight() - $el.outerHeight() - 5]);
        this.impetus[i].setValues($el.position().left, $el.position().top);
      }
    })

    // Show correct count on screen for each group
    $("#map-reward-groups .reward-group").each((i, n) => {
      const rewardGroupId = $(n).data("group-id")
      $(".reward-count", n).text(groupCompletedCount[rewardGroupId]);
    })

    // Update tutorial status from scanData
    const tutorialValueFromScanData = BaseGameMyst.findStationScanData("tutorial", scanData);
    if (tutorialValueFromScanData === "completed") {
      this.firstVisit = false;
    }
  }

  /**
   * When user leave the game, reset the game backpack
   */
  resetRewards() {
    $("#map .pin").removeClass("completed current");

    $("#map .map-reward").each((i, el) => {
      const $el = $(el);
      $el.removeAttr("data-item-index")
      $el.removeAttr("style");
      this.impetus[i].setValues($el.position().left, $el.position().top);
    })

    $("#map-reward-groups .reward-group").each((i, el) => {
      $(".reward-count", el).text("0");
    })
  }

  /**
   * Show map
   */
  showMap(showReward = false) {
    this.$mapEl.addClass("shown");

    // Pause ending screen timer
    if (this.game.endingScreenTimer.currentTimeline) {
      this.game.endingScreenTimer.pauseTimer();
    }

    if (!this.mapShown) {
      this.mapShown = true;
      this.animateIn(showReward);
    }
  }

  /**
   * Hide map
   */
  hideMap() {
    if (this.mapShown) {
      this.mapShown = false;
      this.animateOut();
    }
  }

  animateIn(showReward = false) {
    this.killTimeline(this.currentTimeline);
    this.currentTimeline = gsap.timeline();

    // Show background
    this.currentTimeline.to(this.$mapEl.find(".background-overlay"), {
      alpha: 1.0,
      duration: 0.75,
      ease: "power2.inOut"
    });

    // Play sound
    this.currentTimeline.add(() => {
      this.game.audio.play(this.game.data.global.sounds.sac_ouvre, 1.0);
    })

    // Show content
    this.currentTimeline.to(this.$mapEl.find("#map-inner"), {
      y: 0,
      duration: 1.25,
      delay: 0.25,
      ease: "power2.inOut"
    });

    // Check if it's the first visit of the map
    this.currentTimeline.add(() => {
      const rewardPopupInterval = this.game.settings.mapRewardPopupInterval || 5;

      // Show welcome popup on first map visit
      if (this.firstVisit) {
        this.nextTutorialPopup();
      } else if (this.completedCount !== 0 && this.completedCount % rewardPopupInterval === 0) {
        // Show reward popup by steps defined in rewardPopupInterval
        this.nextRewardPopup();
      }
    });
  }

  animateOut() {
    this.killTimeline(this.currentTimeline);
    this.currentTimeline = gsap.timeline();
    this.tutorialCompleted = true;

    // Hide content
    this.currentTimeline.to(this.$mapEl.find("#map-inner"), {
      y: "-115%",
      duration: 1.25,
      delay: 0.25,
      ease: "power2.inOut"
    });

    // Play sound
    this.currentTimeline.add(() => {
      this.game.audio.play(this.game.data.global.sounds.sac_ferme, 1.0);
    }, 0.25)

    // Hide background
    this.currentTimeline.to(this.$mapEl.find(".background-overlay"), {
      alpha: 0.0,
      duration: 0.75,
      ease: "power2.inOut"
    });

    // Hide all opened popup
    this.currentTimeline.add(() => {
      this.resetAllPopups();
      this.$mapEl.removeClass("shown");

      // Reset and play ending screen timer
      if (this.game.endingScreenTimer.currentTimeline) {
        this.game.endingScreenTimer.resetTimer();
      }
    })
  }

  nextRewardPopup() {
    // Only show reward popup when map tutorial is completed
    if (this.tutorialCompleted && this.mapShown) {
      // Prevent interaction behind popup overlay
      this.$mapEl.find("#map-popup-container").addClass("shown");

      // Find popup object
      const $nextPopup = this.$mapEl.find("#map-reward-overlay .map-reward-step");

      // Update text
      $nextPopup.find("b").text(`${this.completedCount} missions`)

      // Animate in/out
      this.animatePopup(null, $nextPopup);
    }
  }

  /**
   * Go to next step of the map tutorial
   */
  nextTutorialPopup() {
    if (this.mapShown) {
      this.firstVisit = false;
      this.game.mqtt.updateRFID("tutorial", "completed");

      // Prevent interaction behind popup overlay
      this.$mapEl.find("#map-popup-container").addClass("shown");

      const $steps = this.$mapEl.find("#map-tutorial-overlay .map-tutorial-step");
      const $previousPopup = this.mapTutorialStep !== 0 ? $steps.eq(this.mapTutorialStep - 1) : [];
      const $nextPopup = this.mapTutorialStep + 1 <= $steps.length ? $steps.eq(this.mapTutorialStep) : [];
      this.mapTutorialStep++;

      // Animate in/out
      this.animatePopup($previousPopup, $nextPopup, () => {
        if (!$nextPopup.length) {
          // Allow interaction behind popup overlay
          this.$mapEl.find("#map-popup-container").removeClass("shown");

          this.$mapEl.find("#map-tutorial-overlay .map-tutorial-step").removeClass("shown");
          this.tutorialCompleted = true;
        }
      });
    }
  }

  hideRewardPopup() {
    // Allow interaction behind popup overlay
    this.$mapEl.find("#map-popup-container").removeClass("shown");

    const $previousPopup = this.$mapEl.find("#map-reward-overlay .map-reward-step");

    // Animate out
    this.animatePopup($previousPopup, []);
  }

  animatePopup($previousPopup, $nextPopup, callback = null) {
    this.killTimeline(this.popupTimeline);
    this.popupTimeline = gsap.timeline();

    // Hide previous step
    if ($previousPopup && $previousPopup.length && $previousPopup.find(".container").is(".shown")) {
      this.popupTimeline.add(() => {
        $previousPopup.find(".container").removeClass("shown");
      });

      // Hide content
      this.popupTimeline.to($previousPopup.find(".container"), {
        y: 180,
        alpha: 0.0,
        duration: 0.75,
        ease: "power1.inOut"
      });

      // Hide zone overlay
      this.popupTimeline.to($previousPopup.find(".map-cover"), {
        alpha: 0.0,
        duration: 0.75,
        ease: "power1.inOut"
      });

      // Hide container button
      if ($previousPopup.find(".container-button").length) {
        this.popupTimeline.to($previousPopup.find(".container-button"), {
          alpha: 0.0,
          scale: 0.0,
          duration: 0.75,
          ease: "power1.inOut"
        }, "<=");
      }
    }

    // Show next step
    if ($nextPopup && $nextPopup.length) {

      // Show zone overlay
      this.popupTimeline.fromTo($nextPopup.find(".map-cover"), {
        alpha: 0.0,
      }, {
        alpha: 1.0,
        duration: 0.60,
        ease: "power1.inOut"
      });

      // Show content
      this.popupTimeline.fromTo($nextPopup.find(".container"), {
        alpha: 0.0,
        y: -180
      }, {
        alpha: 1.0,
        y: 0,
        duration: 0.60,
        ease: "power1.inOut"
      }, '<=');

      // Show container title
      if ($nextPopup.find(".container-title").length) {
        this.popupTimeline.fromTo($nextPopup.find(".container-title"), {
          '--title-width': "0%"
        }, {
          '--title-width': "100%",
          duration: 0.45,
          ease: "power2.out"
        });
        this.popupTimeline.fromTo($nextPopup.find(".container-title-inner"), {
          alpha: 0.0
        }, {
          alpha: 1.0,
          duration: 0.30,
          ease: "power1.in"
        });
      }

      // Show container button
      if ($nextPopup.find(".container-button").length) {
        this.popupTimeline.fromTo($nextPopup.find(".container-button"), {
          alpha: 0.0,
          scale: 0.0
        }, {
          alpha: 1.0,
          scale: 1.0,
          duration: 0.75,
          ease: "power2.out"
        });

        // Enable button animations
        $nextPopup.find("button.pulse-animation, button.up-down-animation").addClass("play-animation");
      }

      this.popupTimeline.add(() => {
        $nextPopup.find(".container").addClass("shown");
      }, '<=');
    }

    // Callback
    if (callback && typeof callback === "function") {
      this.popupTimeline.add(() => {
        callback();
      });
    }
  }

  resetAllPopups() {
    const $popupContainer = this.$mapEl.find("#map-popup-container");
    $popupContainer.removeClass("shown");
    $popupContainer.find(".container").removeClass("shown");
    $popupContainer.find(".container").css("opacity", 0);
    $popupContainer.find(".map-cover").css("opacity", 0);
  }

  enable() {
    $("#map-button-container").addClass("shown");
    this.disabled = false;
  }

  disable() {
    $("#map-button-container").removeClass("shown");
    this.disabled = true;
  }

  killTimeline(timeline) {
    if (timeline) {
      timeline.kill();
      timeline = null;
    }
  }

  /**
   * Reset function, used to go back clean version of the map/backpack
   */
  reset() {
    //console.log("map reset");

    this.firstVisit = true;
    this.tutorialCompleted = false;
    this.killTimeline(this.popupTimeline);
    this.mapTutorialStep = 0;
    this.completedCount = 0;

    this.rewardLastDraggedEl = null;
    this.rewardzIndexTimeout = false;
    this.rewardzIndexCounter = 0;

    this.resetRewards();
  }
}
